// extracted by mini-css-extract-plugin
export default {"CreateBlankContract":"_CreateBlankContract--TwRZ3","Button":"_Button--l2kP_","Divider":"_Divider--DOs8X"};